import React from 'react';
import { Provider } from 'react-redux';
import './App.css';
import StripeProv from './StripeProv';
import store from './store';

const App = () => {
  return (
  <div>
    <StripeProv />
  </div>
);
  }

// wrap ConnectedApp component with JssProvider to prevent CSS class naming collisions
const ConnectedProviderApp = () => (
  <Provider store={store}>
      <App />
  </Provider>
);

export default ConnectedProviderApp;
